import React from 'react';
import { motion } from 'framer-motion';
import { TOPIC_CLUSTERS, RECOMMENDATIONS } from '../../data/mockData';
import { useKPIs } from '../../context/KPIContext';
import { KPICard } from '../../components/ui/KPICard';
import { HotTopicItem } from '../../components/ui/HotTopicItem';
import { FileText, ShieldAlert } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function MgmtDashboard() {
  const navigate = useNavigate();
  const {
    kpis
  } = useKPIs();
  // All topics sorted by mention count, concerns first
  const sortedTopics = [...TOPIC_CLUSTERS].sort((a, b) => {
    if (a.type === 'concern' && b.type !== 'concern') return -1;
    if (a.type !== 'concern' && b.type === 'concern') return 1;
    return b.mentionCount - a.mentionCount;
  });
  return <div className="space-y-10 pb-20" data-id="element-314">
      <header className="flex justify-between items-end" data-id="element-315">
        <div data-id="element-316">
          <h1 className="text-3xl font-bold text-white mb-2" data-id="element-317">
            Executive Dashboard
          </h1>
          <p className="text-secondary" data-id="element-318">
            Strategic overview of organizational health.
          </p>
        </div>
        <button onClick={() => navigate('/mgmt/digest')} className="flex items-center space-x-2 bg-white/5 text-white border border-white/10 px-4 py-2 rounded-lg font-medium hover:bg-white/10 transition-colors" data-id="element-319">
          <FileText className="w-4 h-4" data-id="element-320" />
          <span data-id="element-321">View Monthly Digest</span>
        </button>
      </header>

      {/* Executive Snapshot */}
      <section data-id="element-322">
        <h2 className="text-xl font-semibold text-white mb-6" data-id="element-323">
          Executive Snapshot
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-324">
          {kpis.map((kpi, idx) => <motion.div key={kpi.id} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: idx * 0.05
        }} data-id="element-325">
              <KPICard key={kpi.id} kpi={kpi} role="management" data-id="element-326" />
            </motion.div>)}
        </div>
      </section>

      {/* Organizational Concerns with Inline Recommendations */}
      <section className="glass-panel p-6 rounded-xl" data-id="element-327">
        <div className="mb-6 flex items-center space-x-3" data-id="element-328">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-danger/10 text-danger" data-id="element-329">
            <ShieldAlert className="h-5 w-5" data-id="element-330" />
          </div>
          <div data-id="element-331">
            <h2 className="text-lg font-semibold text-white" data-id="element-332">
              Organizational Concerns & Trends
            </h2>
            <p className="text-xs text-secondary" data-id="element-333">
              AI-detected patterns with strategic recommendations
            </p>
          </div>
        </div>

        <div className="space-y-1" data-id="element-334">
          {sortedTopics.map((topic, idx) => {
          const kpiBucket = kpis.find(k => k.id === topic.kpiBucketId);
          const recommendation = RECOMMENDATIONS.find(r => r.relatedTopicId === topic.id);
          return <HotTopicItem key={topic.id} topic={topic} index={idx} kpiBucketName={kpiBucket?.name || 'Unknown KPI'} recommendation={recommendation} data-id="element-335" />;
        })}
        </div>
      </section>
    </div>;
}